"use client";

import { ApiDesigners } from "@/api/designers";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";

export const useDesignersData = () => {
  const { data: designers, isLoading: loadingDesigners } = useLocalizedQuery({
    queryKey: ["designers"],
    queryFn: lang => ApiDesigners.getDesigners(lang),
  });

  const { data: designersPage, isLoading: loadingPage } = useLocalizedQuery({
    queryKey: ["designersPage"],
    queryFn: lang => ApiDesigners.getDesignersPage(lang),
  });

  return { designers, loadingDesigners, designersPage, loadingPage };
};
